import { PinInput } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props {
  name: string;
  fieldCount: number;
}

export const HookedPinInput = (props: Props) => {
  const { name, fieldCount } = props;

  const {
    field: { ref, value = '', onChange },
  } = useController({ name });

  return <PinInput ref={ref} value={value} onChange={onChange} fieldCount={fieldCount} />;
};
